import type { CSSProperties } from "react";

/**
 * IDPP brand mark — "eye + bars": barcode bars beside a QR finder eye on the
 * brand indigo tile. Geometry is kept identical to /public/favicon.svg so the
 * in-app logo and the browser/app icon are the exact same mark everywhere.
 *
 * The wordmark text ("IDPP.net") always sits next to it in the lockups, so the
 * SVG is aria-hidden to avoid a duplicated "IDPP" for screen readers.
 */
export function BrandMark({
  size = 24,
  className,
  style,
}: {
  size?: number;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      style={style}
      aria-hidden="true"
      focusable="false"
    >
      <rect width="100" height="100" rx="22" fill="#4746f3" />
      <g fill="#ffffff">
        <rect x="25" y="35" width="5" height="30" rx="1.3" />
        <rect x="33" y="35" width="3" height="30" rx="1.3" />
        <rect x="39" y="35" width="5" height="30" rx="1.3" />
      </g>
      <rect x="52" y="35" width="30" height="30" rx="7.5" fill="none" stroke="#ffffff" strokeWidth="5.5" />
      <rect x="61" y="44" width="12" height="12" rx="3" fill="#ffffff" />
    </svg>
  );
}
